/* ============================================================
   Vantor — app-236 PDP behaviour. <main data-pdp="cap|tent|storage|general">
   ============================================================ */
(function (V) {
  var main = document.querySelector('[data-pdp]'); if (!main) return;
  var kind = main.getAttribute('data-pdp');
  var val = function (name) { var i = main.querySelector('input[name="' + name + '"]:checked'); return i ? i.value : null; };

  /* app-240: every figure is Shopify's. */
  function priceHTML(o) {
    if (!o) return '—';
    return o.state === 'pre' && o.savings > 0
      ? '<s>' + V.money(o.list) + '</s>' + V.money(o.total) + '<small>presale price</small>'
      : V.money(o.list);
  }
  // pills + status note follow the SELECTED variant; the root flag drives the .when-<kind>-0/1 CSS
  function paintOffer(kindName, v, noun) {
    var o = V.offerOf(v), st = V.stateOf(v);
    V.setFlag(kindName, st);
    var due = main.querySelector('[data-pill="due"]'), off = main.querySelector('[data-pill="off"]');
    if (st === 'pre') {
      if (due) { due.hidden = !(o.due > 0); due.textContent = due.hidden ? '' : V.money(o.due) + ' deposit'; }
      if (off) { off.hidden = !(o.savings > 0); off.textContent = off.hidden ? '' : V.money(o.savings) + ' off'; }
    }
    var note = main.querySelector('[data-note]');
    if (note) note.textContent = V.noteFor(v, noun);
    main.querySelector('[data-price]').innerHTML = priceHTML(o);
    return st;
  }

  /* TPC-1141: the Cap page sells one exact Cap. TPC-1188: the shopper chooses it here: a supported truck, then one of that
     truck's actual beds (Vantor.fitmentOf), the Window and Storage. The truck radios are painted from Vantor.CATALOG.trucks and
     the bed radios from the chosen truck, as the Builder paints them, so a truck change always clears the bed and a truck with one
     bed has it chosen. An entry link (?truck=<id>&bed=<id>, optionally window=<id>) checks the same controls when the whole link is
     valid; any other link leaves them unchosen. Nothing is sold until a bed is chosen. */
  var bedsFor = null;   // truck id the bed radios are painted for
  function truckOf(id) { return V.CATALOG.trucks.find(function (t) { return t.id === id; }) || null; }
  function capLabel(lengthId) {
    var l = V.CATALOG.cap.lengths.find(function (x) { return x.id === lengthId; });
    return l ? l.label : lengthId;
  }
  function paintTrucks() {
    main.querySelector('[data-trucks]').innerHTML = V.CATALOG.trucks.map(function (t) {
      return '<label class="seg__opt"><input type="radio" name="truck" value="' + t.id + '"><span class="seg__face">' + t.model + '<small>' + t.make + '</small></span></label>';
    }).join('');
  }
  function paintBeds(truck, want) {
    var box = main.querySelector('[data-beds]');
    bedsFor = truck ? truck.id : null;
    if (!truck) { box.innerHTML = '<span class="seg__hint">Select a truck first</span>'; return; }
    box.innerHTML = truck.beds.map(function (b) {
      var on = b.id === want || truck.beds.length === 1;
      return '<label class="seg__opt"><input type="radio" name="bed" value="' + b.id + '"' + (on ? ' checked' : '') + '>' +
        '<span class="seg__face">' + b.label + ' bed<small>Cap ' + capLabel(b.length) + '</small></span></label>';
    }).join('');
  }
  function check(name, value) {
    main.querySelectorAll('input[name="' + name + '"]').forEach(function (i) { if (i.value === value) i.checked = true; });
  }
  if (kind === 'cap') {
    paintTrucks();
    var q = new URLSearchParams(location.search), linkWin = q.get('window');
    var linked = V.fitmentOf(q.get('truck'), q.get('bed')) &&
      (linkWin === null || V.CATALOG.cap.windows.some(function (w) { return w.id === linkWin; }));
    if (linked) {
      check('truck', q.get('truck'));
      paintBeds(truckOf(q.get('truck')), q.get('bed'));
      if (linkWin) check('window', linkWin);
    } else paintBeds(null);
  }
  var capFlag = document.documentElement.getAttribute('data-inv-cap');

  function paintCap() {
    var truck = truckOf(val('truck')), win = val('window');
    if ((truck ? truck.id : null) !== bedsFor) paintBeds(truck, null);
    var bed = truck && truck.beds.find(function (b) { return b.id === val('bed'); });
    var fitment = bed ? V.fitmentOf(truck.id, bed.id) : null;
    var name = truck ? truck.make + ' ' + truck.model : '';
    var storage = val('storage') === 'box';

    // gallery follows the window choice
    main.querySelectorAll('[data-gallery]').forEach(function (g) { g.hidden = g.getAttribute('data-gallery') !== win; });

    // selected-value echoes in the legends
    var W = V.CATALOG.cap.windows.find(function (x) { return x.id === win; });
    main.querySelector('[data-echo="truck"]').textContent = name || 'Not selected';
    main.querySelector('[data-echo="bed"]').textContent = bed ? bed.label : 'Not selected';
    main.querySelector('[data-echo="window"]').textContent = W.label;
    main.querySelector('[data-fits]').textContent = fitment ? 'Fits your ' + name + ' · ' + bed.label + ' bed'
      : truck ? 'Choose the bed length of your ' + name + '.' : 'Select your truck, then its bed length.';
    var route = main.querySelector('[data-cap-route]');
    route.hidden = !!fitment;
    route.setAttribute('href', route.getAttribute('href').split('?')[0] + '?' + (truck ? 'truck=' + truck.id + '&' : '') +
      'window=' + win + (storage ? '&gear=storage' : ''));

    // installed storage: the box tile is the Cap's Storage option
    var st = fitment ? V.capStorage({ fitment: fitment, window: win }) : { price: null, state: null };
    var box = main.querySelector('input[name="storage"][value="box"]');
    box.disabled = st.state === null || st.state === 'out';
    if (box.disabled && box.checked) { main.querySelector('input[name="storage"][value="none"]').checked = true; storage = false; }
    main.querySelector('[data-storage-blocked]').hidden = st.state !== 'out';
    main.querySelector('[data-storage-preorder]').hidden = st.state !== 'pre';

    var sel = fitment ? { fitment: fitment, window: win, storage: storage } : null;
    var v = sel && V.variantFor('cap', sel);
    if (v) paintOffer('cap', v, 'Cap');
    else {
      if (capFlag !== null) document.documentElement.setAttribute('data-inv-cap', capFlag);
      main.querySelector('[data-price]').textContent = '—';
      main.querySelectorAll('[data-pill]').forEach(function (p) { p.hidden = true; p.textContent = ''; });
      var note = main.querySelector('[data-note]');
      if (note) note.textContent = '';
    }
    V.paintSummary(sel ? V.quote({ cap: sel, tent: false }) : null,
      { cfg: (fitment || name || 'No truck selected') + ' · ' + W.label + (storage ? ' · Storage installed' : ''),
        blocked: truck ? 'Choose a bed length' : 'Select your truck' });
  }

  function paintTent() {
    var v = V.variantFor('tent');
    paintOffer('tent', v, 'tent');
    V.paintSummary(V.quote({ cap: null, tent: true }), { cfg: 'Hard-shell rooftop tent' });
  }

  function paintStorage() {
    V.paintSummary(null, { cfg: 'Installed in your Cap', blocked: 'Installed with a Cap' });
  }

  // TPC-164: any product with no page of its own. The page's `variant` control holds the chosen variant:
  // a select when the product has more than one, whose chosen title goes under the product's.
  function paintGeneral() {
    var control = main.querySelector('[name="variant"]'), id = control.value;
    var title = control.options ? control.options[control.selectedIndex].text : '';
    var v = V.productVariant(id), st = paintOffer('general', v, 'order');
    // in stock says nothing under the pills: "Ships in 5–7 days" is not confirmed for a product the client adds
    if (st === 'in') main.querySelector('[data-note]').textContent = '';
    // the button reads "Sold out", not the title and "sold out", which does not fit it at phone width
    var q = V.quote({ cap: null, tent: false, item: { id: id, note: title } });
    V.paintSummary(q.blocked ? null : q, { cfg: title, blocked: st === 'out' ? 'Sold out' : 'Unavailable' });
  }

  /* ---------- app-251 HQA: PDP image galleries ----------------------
     One model per scope: a gallery has ONE selected image and the thumb row
     never reorders. The stage is a native scroll-snap strip — the shopper
     swipes it under 1024px; the arrows and thumbs drive it above. Thumb i and
     slide i are the same image: DOM order is the only pairing, so there are no
     ids and no per-product data. Every [data-gal] scope keeps its own index,
     which is why the Cap's Hardshell and Sliding galleries never share one.
     ------------------------------------------------------------------ */
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var galleries = [];   // re-apply hooks, one per live scope

  function stripScroll(strip, left, smooth) {
    var behavior = (smooth && !(reduceMotion && reduceMotion.matches)) ? 'smooth' : 'auto';
    if (strip.scrollTo) strip.scrollTo({ left: left, behavior: behavior });
    else strip.scrollLeft = left;
  }

  // TPC-1048: a video plays only while its slide is on screen. The shopper starts it; nothing here ever does.
  function pauseVideos(slides, keep) {
    for (var k = 0; k < slides.length; k++) {
      if (k === keep) continue;
      var videos = slides[k].querySelectorAll('video');
      for (var j = 0; j < videos.length; j++) videos[j].pause();
    }
  }

  function initGallery(root) {
    var strip = root.querySelector('[data-gal-strip]');
    var thumbs = root.querySelectorAll('[data-gal-thumb]');
    var slides = strip ? strip.querySelectorAll('.pdp-gal__slide') : [];
    // the Cap hides the other Window's scope: whatever it was playing stops, one slide or many
    function pauseHidden() { if (root.hidden) pauseVideos(slides, -1); }
    var n = slides.length < thumbs.length ? slides.length : thumbs.length;
    if (!strip || n < 2) {                                // one medium needs no gallery
      galleries.push({ hold: function () {}, apply: pauseHidden });
      return;
    }

    var countEl = root.querySelector('[data-gal-count]');
    var statusEl = root.querySelector('[data-gal-status]');
    var index = 0;        // the selected image
    var busy = false;     // a programmatic scroll is in flight — ignore what the scroll says
    var quietTimer = null, ceilingTimer = null;
    var frame = 0;

    // `silent` paints the thumbs and the counter but leaves the live region alone,
    // which is what page load needs: nothing may be announced before the shopper acts.
    function paintGallery(silent) {
      for (var k = 0; k < n; k++) thumbs[k].setAttribute('aria-pressed', k === index ? 'true' : 'false');
      var onVideo = slides[index].querySelectorAll('video').length > 0;
      if (countEl) {
        countEl.textContent = (index + 1) + ' / ' + n;
        countEl.classList.toggle('pdp-gal__count--over-video', onVideo);   // TPC-1048: clear of the native controls
      }
      pauseVideos(slides, index);
      if (silent || !statusEl) return;
      var said = (onVideo ? 'Video ' : 'Image ') + (index + 1) + ' of ' + n;
      if (statusEl.textContent !== said) statusEl.textContent = said;
    }

    function syncFromScroll() {
      var w = strip.clientWidth;
      if (!w) return;                                     // hidden scope: never divide by 0
      var k = Math.round(strip.scrollLeft / w);
      if (k < 0) k = 0; else if (k > n - 1) k = n - 1;
      if (k === index) return;
      index = k;
      paintGallery();
    }

    // The shopper's own scroll is authoritative once a programmatic one is over
    // or has been taken over, so settling always re-reads what is on screen.
    function settle() {
      if (quietTimer) { clearTimeout(quietTimer); quietTimer = null; }
      if (ceilingTimer) { clearTimeout(ceilingTimer); ceilingTimer = null; }
      if (!busy) return;
      busy = false;
      syncFromScroll();
    }

    // The hold ends when the strip goes QUIET, not a fixed time after the scroll
    // began. A browser scales a smooth scroll's duration with its distance, so a
    // 1 -> 4 sweep can outlast any fixed timeout; releasing mid-sweep would read
    // the position the strip is passing through and flash the thumbs the brief
    // forbids. Every scroll event re-arms HOLD_QUIET (see the scroll listener), so
    // this is the one path that works with and without `scrollend`. HOLD_CEILING
    // is the guarantee that the hold always ends, even if the scroll is cancelled
    // before it ever moves.
    var HOLD_START = 500;      // grace before the first scroll event of a programmatic scroll
    var HOLD_QUIET = 150;      // quiet period after the last scroll event
    var HOLD_CEILING = 2500;   // hard ceiling — the hold always releases; longer than any smooth sweep

    function hold() {
      busy = true;
      if (quietTimer) clearTimeout(quietTimer);
      if (ceilingTimer) clearTimeout(ceilingTimer);
      quietTimer = setTimeout(settle, HOLD_START);
      ceilingTimer = setTimeout(settle, HOLD_CEILING);
    }

    function holdQuiet() {
      if (quietTimer) clearTimeout(quietTimer);
      quietTimer = setTimeout(settle, HOLD_QUIET);
    }

    function goTo(i, smooth) {
      var w = strip.clientWidth;
      if (!w) return;                                     // hidden: re-applied when it comes back
      if (Math.abs(strip.scrollLeft - i * w) < 1) return; // already there: no scroll, so no hold to arm
      hold();
      stripScroll(strip, i * w, smooth);
    }

    // Selection is set here and now, so clicking thumb 4 from 1 never flashes 2 and 3.
    function select(i, smooth) {
      index = i < 0 ? 0 : (i > n - 1 ? n - 1 : i);
      paintGallery();
      goTo(index, smooth);
    }

    function step(delta) {
      var next = index + delta, wrapped = false;
      if (next < 0) { next = n - 1; wrapped = true; }
      else if (next > n - 1) { next = 0; wrapped = true; }
      select(next, !wrapped);                             // a wrap jumps, it never sweeps every slide
    }

    function onThumb(i) { return function () { select(i, true); }; }
    for (var t = 0; t < n; t++) thumbs[t].addEventListener('click', onThumb(t));

    var prevBtn = root.querySelector('[data-gal-prev]');
    var nextBtn = root.querySelector('[data-gal-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    // arrow keys on the strip or on a thumb; focus stays where it is
    root.addEventListener('keydown', function (e) {
      var back = e.key === 'ArrowLeft', fwd = e.key === 'ArrowRight';
      if (!back && !fwd) return;
      var here = e.target === strip;
      for (var k = 0; k < n && !here; k++) here = thumbs[k] === e.target;
      if (!here) return;
      e.preventDefault();
      step(back ? -1 : 1);
    });

    strip.addEventListener('scroll', function () {
      if (busy) holdQuiet();   // un-throttled on purpose: the hold measures quiet, not frames
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        if (busy) return;
        syncFromScroll();
      });
    });
    strip.addEventListener('scrollend', settle);   // where supported, no wait for the quiet period
    strip.addEventListener('pointerdown', settle);        // the shopper took the strip over
    strip.addEventListener('wheel', settle, { passive: true });

    // re-apply, always instantly — and only when the strip has actually drifted, so
    // an unrelated option change (bed length, the storage add-on) does not re-snap
    // the stage or arm a hold on a gallery nobody touched
    galleries.push({
      hold: hold,
      apply: function () {
        pauseHidden();
        goTo(index, false);                               // goTo no-ops when the strip is already on its slide
      }
    });

    // A reload or a bfcache restore can hand the strip back on another slide. Adopt
    // it so the thumbs and the counter match what is on screen, but leave the live
    // region empty — page load announces nothing.
    var restored = strip.clientWidth ? Math.round(strip.scrollLeft / strip.clientWidth) : 0;
    if (restored > 0) {
      index = restored > n - 1 ? n - 1 : restored;
      paintGallery(true);
    }
  }

  function initGalleries() {
    var scopes = main.querySelectorAll('[data-gal]');
    for (var s = 0; s < scopes.length; s++) initGallery(scopes[s]);
  }

  // A scope that was hidden lost its scroll position, and a resize changed what
  // one slide is worth — both would leave a half slide on screen.
  function reapplyGalleries() {
    for (var k = 0; k < galleries.length; k++) galleries[k].apply();
  }

  var viewportFrame = 0;
  function onViewportChange() {
    // hold now, not in the frame: a scroll fired by the resize would otherwise
    // read the old scrollLeft against the new width and pick the wrong slide
    for (var k = 0; k < galleries.length; k++) galleries[k].hold();
    if (viewportFrame) return;
    viewportFrame = requestAnimationFrame(function () { viewportFrame = 0; reapplyGalleries(); });
  }
  window.addEventListener('resize', onViewportChange);
  window.addEventListener('orientationchange', onViewportChange);

  /* ---------- end: PDP image galleries ------------------------------ */

  var paint = { cap: paintCap, tent: paintTent, storage: paintStorage, general: paintGeneral }[kind];

  // before the first paint and independent of kind: paintStorage returns early at
  // inventory 0, and a paint that throws must not leave the galleries dead
  initGalleries();

  // a page with no painter is its galleries and what Liquid printed
  if (!paint) return;

  main.addEventListener('change', paint);
  document.addEventListener('vantor:state', paint);
  // after paint, so the Cap window toggle has already un-hidden the scope
  main.addEventListener('change', reapplyGalleries);
  document.addEventListener('vantor:state', reapplyGalleries);
  paint();

  // deep link: #storage pre-selects nothing, just scrolls (native) — but ?addon=storage pre-checks the box
  // when the entry link's configuration offers installed storage
  var box = kind === 'cap' && main.querySelector('input[name="storage"][value="box"]');
  if (box && /(?:^|[?&])addon=storage(?:&|$)/.test(location.search) && !box.disabled) { box.checked = true; paint(); }
})(window.Vantor);
